import { EditSupervBaseComponent } from './edit-supervbase/edit-supervbase.component';
import { AddSupervBaseComponent } from './add-supervbase/add-supervbase.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListSupervBaseComponent } from './list-supervbase/list-supervbase.component';

export const routesSupervBase: Routes = [
    { path: 'page-supervbase', component: ListSupervBaseComponent },
    { path: 'page-supervbase/add', component: AddSupervBaseComponent },
    { path: 'page-supervbase/:id/edit', component: EditSupervBaseComponent },
];

export const SupervBaseRoutes: ModuleWithProviders = RouterModule.forChild(routesSupervBase);
